export const getBrowserLocale = () => navigator.language;

export default getBrowserLocale;
